module.exports = __webpack_public_path__ + "img/partner2.365bd770.jpg";